import React from 'react';
import { Box, Typography } from '@mui/material';
import { Instagram, Youtube } from 'lucide-react';
import { MusicNote } from '@mui/icons-material';
import { useThemeContext } from '../../../hook/useThemeManager';
import { theme } from '../../../constants/theme';

interface SocialUsernameProps {
    platform: string;
    username: string;
    size?: 'small' | 'medium' | 'large';
}

const getPlatformIcon = (platform: string) => {
    switch (platform.toLowerCase()) {
        case 'instagram':
            return Instagram;
        case 'youtube':
            return Youtube;
        case 'tiktok':
            return MusicNote;
        default:
            return Instagram;
    }
};

const getPlatformColor = (platform: string) => {
    switch (platform.toLowerCase()) {
        case 'instagram':
            return '#E4405F';
        case 'youtube':
            return '#FF0000';
        case 'tiktok':
            return '#000000';
        default:
            return '#E4405F';
    }
};

const getIconSize = (size: 'small' | 'medium' | 'large') => {
    switch (size) {
        case 'small':
            return 16;
        case 'large':
            return 24;
        default:
            return 20;
    }
};

const getFontSize = (size: 'small' | 'medium' | 'large') => {
    switch (size) {
        case 'small':
            return '0.875rem';
        case 'large':
            return '1.125rem';
        default:
            return '1rem';
    }
};

export function SocialUsername({ platform, username, size = 'medium' }: SocialUsernameProps) {
    const { themeStyle } = useThemeContext();
    const IconComponent = getPlatformIcon(platform);
    const platformColor = getPlatformColor(platform);
    const iconSize = getIconSize(size);
    const fontSize = getFontSize(size);

    return (
        <Box display="flex" alignItems="center" gap={1}>
            <IconComponent size={iconSize} style={{ color: platformColor }} />
            <Typography
                variant="body2"
                sx={{
                    color: theme[themeStyle].tag_white,
                    fontSize: fontSize,
                    fontWeight: 500,
                }}>
                @{username}
            </Typography>
        </Box>
    );
}
